export default {
  title: 'Zapłać przez PayPal',
  error: 'Nie można było zrealizować płatności PayPal. Spróbuj ponownie.',
};
